document.addEventListener("DOMContentLoaded", () => {

  // Run only on products tagged "Premium Printshield Case"
  if (!window.isPhoneCase) return;

  const images = document.querySelectorAll(".product__media img");

if (images.length < 2) return;

const previewImage = images[0]; // design only
const mockupImage = images[1];  // iPhone 16 pro mockup
if (!previewImage || !mockupImage) return;

// Cache the second thumbnail button once
const secondThumbnailButton = document.querySelector(
  '.thumbnail-list__item[data-media-position="2"] button'
);

const frame = document.createElement("img");
frame.className = "cc-frame-overlay";
mockupImage.parentElement.appendChild(frame);

  // Default preview
  frame.src = window.phoneFrames["iphone-16-pro"];
  frame.classList.add("active");
 
  // Default state
previewImage.style.display = "";
mockupImage.style.display = "none";

  let previousDetectedKey = null;

  function updateFrame() {

  let detectedKey = previousDetectedKey;

// Find ALL checked Globo dropdown radios
const selectedOptions = document.querySelectorAll(
  'input[data-type="dropdown"]:checked'
);

selectedOptions.forEach(option => {

  const key = option.value
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");

  // Detect even if the frame image doesn't exist yet
  if (Object.prototype.hasOwnProperty.call(window.phoneFrames, key)) {
    detectedKey = key;
  }

});

  if (!detectedKey) {
    previewImage.style.display = "";
    mockupImage.style.display = "none";
    previousDetectedKey = null;
    return;
  }

  // Switch gallery only when model changes
  if (previousDetectedKey !== detectedKey) {

    previousDetectedKey = detectedKey;

    setTimeout(() => {
  secondThumbnailButton?.click();
}, 100);

  }

  previewImage.style.display = "none";
  mockupImage.style.display = "";

  const newSrc = window.phoneFrames[detectedKey];

// If this model doesn't have a frame yet,
// keep showing the previous one instead of disappearing.
if (!newSrc) return;

if (frame.dataset.currentFrame === newSrc) return;

frame.dataset.currentFrame = newSrc;

frame.classList.remove("active");

setTimeout(() => {
  frame.src = newSrc;
  frame.classList.add("active");
}, 50);

}

  // Run once on page load
updateFrame();

// Listen for Globo dropdown changes
document.addEventListener("change", (e) => {

  if (!e.target.matches('input[data-type="dropdown"]')) return;

  setTimeout(updateFrame, 50);

});

});


async function updateCartFrames() {

  if (!window.phoneFrames) return;

  const cartItems = document.querySelectorAll("[data-cart-item]");

  if (!cartItems.length) return;

  let cartData;

  try {
    const response = await fetch("/cart.js", {
      cache: "no-store"
    });

    if (!response.ok) return;

    cartData = await response.json();

  } catch (error) {
    console.error("Custom Chics: Could not read cart data", error);
    return;
  }

  if (!cartData?.items?.length) return;


  cartItems.forEach((item, index) => {

    const frame = item.querySelector("[data-cart-frame]");

    if (!frame) return;


    /*
     * Try to identify the corresponding Shopify cart item.
     * Dawn normally keeps cart items in the same order as cart.js.
     */

    let cartItem = cartData.items[index];

    /*
     * If the HTML has a line-item index, use that instead.
     */

    const possibleIndex =
      item.dataset.index ||
      item.dataset.lineIndex ||
      item.getAttribute("data-line-index");

    if (possibleIndex) {

      const numericIndex = parseInt(possibleIndex, 10);

      if (
        !isNaN(numericIndex) &&
        cartData.items[numericIndex - 1]
      ) {
        cartItem = cartData.items[numericIndex - 1];
      }
    }

    if (!cartItem) return;


    let detectedKey = null;


    /*
     * ---------------------------------------------------------
     * 1. FIRST: check Shopify variant option values
     * ---------------------------------------------------------
     */

    const exactValues = [];

    if (Array.isArray(cartItem.options_with_values)) {

      cartItem.options_with_values.forEach(option => {

        if (option?.value) {
          exactValues.push(option.value);
        }

      });

    }


    /*
     * ---------------------------------------------------------
     * 2. Check Shopify line-item properties
     * ---------------------------------------------------------
     */

    if (cartItem.properties) {

      Object.values(cartItem.properties).forEach(value => {

        if (value) {
          exactValues.push(String(value));
        }

      });

    }


    /*
     * ---------------------------------------------------------
     * 3. Check variant title
     * ---------------------------------------------------------
     */

    if (cartItem.variant_title) {
      exactValues.push(cartItem.variant_title);
    }


    /*
     * ---------------------------------------------------------
     * EXACT MODEL MATCH
     * ---------------------------------------------------------
     */

    for (const value of exactValues) {

      const normalized = String(value)
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-");

      if (
        Object.prototype.hasOwnProperty.call(
          window.phoneFrames,
          normalized
        )
      ) {

        detectedKey = normalized;
        break;

      }

    }


    /*
     * ---------------------------------------------------------
     * FALLBACK:
     * Search the complete cart item's data.
     * Longest model names are checked first.
     * ---------------------------------------------------------
     */

    if (!detectedKey) {

      const searchableText = [

        cartItem.title,
        cartItem.variant_title,

        ...(cartItem.options_with_values || [])
          .map(option => option?.value || ""),

        ...Object.values(cartItem.properties || {})

      ]
        .join(" ")
        .trim()
        .toLowerCase();


      const possibleKeys = Object.keys(window.phoneFrames)
        .sort((a, b) => b.length - a.length);


      for (const key of possibleKeys) {

        const readableKey = key
          .replace(/-/g, " ")
          .trim()
          .toLowerCase();

        const escapedKey = readableKey.replace(
          /[.*+?^${}()|[\]\\]/g,
          "\\$&"
        );

        const regex = new RegExp(
          "(^|\\s|:)" +
          escapedKey +
          "(?=\\s|$|\\n|:|\\(|\\))",
          "i"
        );

        if (regex.test(searchableText)) {

          detectedKey = key;
          break;

        }

      }

    }


    /*
     * ---------------------------------------------------------
     * FINAL FALLBACK:
     * Use the existing cart HTML.
     * ---------------------------------------------------------
     */

    if (!detectedKey) {

      const cartText = item.textContent
        .trim()
        .toLowerCase();

      const possibleKeys = Object.keys(window.phoneFrames)
        .sort((a, b) => b.length - a.length);


      for (const key of possibleKeys) {

        const readableKey = key
          .replace(/-/g, " ")
          .trim();

        const escapedKey = readableKey.replace(
          /[.*+?^${}()|[\]\\]/g,
          "\\$&"
        );

        const regex = new RegExp(
          "(^|\\s|:)" +
          escapedKey +
          "(?=\\s|$|\\n|:|\\(|\\))",
          "i"
        );

        if (regex.test(cartText)) {

          detectedKey = key;
          break;

        }

      }

    }


    /*
     * ---------------------------------------------------------
     * NO MODEL = DON'T TOUCH THE EXISTING IMAGE
     * ---------------------------------------------------------
     */

    if (!detectedKey) return;


    const frameUrl = window.phoneFrames[detectedKey];

    if (!frameUrl) return;


    /*
     * Don't repeatedly reload the same PNG.
     */

    if (frame.dataset.currentFrame === frameUrl) return;


    /*
     * ---------------------------------------------------------
     * KEEP YOUR EXISTING SECOND-IMAGE SELECTION
     * ---------------------------------------------------------
     */

    const secondSlideButton = document.querySelector(
      '[data-media-id]:not([data-media-id="' +
      document.querySelector(".product__media-toggle")?.dataset.mediaId +
      '"])'
    );

    if (secondSlideButton) {
      secondSlideButton.click();
    }


    /*
     * ---------------------------------------------------------
     * SET THE PNG
     * ---------------------------------------------------------
     */

    frame.dataset.currentFrame = frameUrl;

    frame.src = frameUrl;

  });

}


/*
 * Initial cart load
 */

document.addEventListener(
  "DOMContentLoaded",
  updateCartFrames
);


/*
 * Re-run whenever Shopify updates the cart drawer
 */

const cartDrawer = document.getElementById("CartDrawer");

if (cartDrawer) {

  let updateTimer;

  const observer = new MutationObserver(() => {

    clearTimeout(updateTimer);

    updateTimer = setTimeout(() => {

      updateCartFrames();

    }, 250);

  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true
  });

}